






























































































































































































































import Vue from 'vue'
import _ from 'lodash'
import * as planningService from '@/services/planning-service'
import moment from 'moment'
import {
  ACTIVATE_SHIFT_LIST,
  COMPANY_FETCH_COMPANY_STRUCTURE,
  COMPLETE_SHIFT_LIST,
  CREATE_SHIFT_NEW,
  DEACTIVATED_SHIFT_LIST,
  DELETE_CALENDAR_ART,
  DELETE_CHECKED_LIST,
  DELETE_PROJECT_SERIEN,
  DELETE_SHIFT,
  EVENT_DRAG_SAVE,
  FETCH_ABSENCE_TOOLTIP,
  FETCH_ADDRESS_NOTE,
  FETCH_CALENDAR_ART_TOOLTIP,
  FETCH_CAPACITY_LIST,
  FETCH_EDIT_SHIFT,
  FETCH_EMPLOYEE_NOTE,
  FETCH_INVOICING_DATA, FETCH_PLANING_FILTER,
  FETCH_SCHEDULER_SETTINGS,
  FETCH_SHIFT_NOTE,
  FETCH_SHIFT_TOOLTIP,
  FIX_PROJECT_SERIE,
  INSERT_CALENDAR_ART,
  LOAD_PLAN,
  LOAD_SHIFT_TEMPLATE_LIST,
  LOAD_SHIFTS,
  MESSAGING_LOAD_NEW_MESSAGES,
  PLANNING_ASSISTANT_SET_SHIFT_TEMPLATE_ITEM,
  SAVE_SCHEDULER_SETTINGS,
  SAVE_SHIFT_ADDRESS_EMPLOYEE_NOTE,
  SCHEDULER_AUTO_PLANNING,
  SET_IS_ALL_DAY_LONG,
} from '@/store/action-types'
import { CheckedShiftList, CompanyStructure, TimeRange } from '@/types'
import {
  AddressNotePayload,
  CompanyFilterValue,
  CreateCalendarEventPayload,
  CreateShiftPayload,
  DeleteCalendarEventPayload,
  EmployeeCapacityPayload,
  EventDropPayload,
  InvoicePayload, PlaningFilterPayload,
  PlanningAssistantPeriodicityPayload,
  PlanningDetailsPayload,
  PlanPayload,
  SchedulerAutoPlanningPayload,
  ShiftListPayload
} from '@/types/payload'
import {
  AddressNoteResponse,
  CreateShiftNewResponse, GetPlaningFilterData,
  InvoiceResponse,
  PlanItem,
  PlanResponse,
  ResponseBase,
  ShiftPlanResponse
} from '@/types/service-response'
import { DatePeriod } from '@/model/DatePeriod'
import { Employee } from '@/model/companyStructure/Employee'
import { EmployeeEvent } from '@/model/planning/EmployeeEvent'
import { EmployeeResource } from '@/model/planning/EmployeeResource'
import { PlannedShift } from '@/model/planning/PlannedShift'
import CompanyFilter from '@/components/planning/CompanyFilter.vue'
import ShiftList from '@/components/planning/ShiftList.vue'
import SchedulerToolbar from '@/components/planning/SchedulerToolbar.vue'
import Scheduler from '@/components/wrappers/Scheduler.vue'
import 'bryntum-scheduler/scheduler.default.css'
import ShiftEditor from '@/components/planning/shift/ShiftEditor.vue'
import ShiftEditDialog from '@/components/planning/shift/ShiftEditDialog.vue'
import {
  ActionsEnum,
  DatePeriodEnum,
  NoteEditMenu,
  SchedulerResourceEnum,
  SecurityArea,
  SecurityComponent,
  ShiftAvailability,
  ShiftFilterScope,
  SnackbarStateEnum,
  ViewEnum
} from '@/types/enums'
import { EventTimePeriod } from '@/model/planning/EventTimePeriod'
import { ShiftEditorPlanningPayload } from '@/model/planning/ShiftEditorPlanningPayload'
import { TranslateResult } from 'vue-i18n'
import { ShiftTemplate } from '@/model/planning/ShiftTemplate'
import {
  COMPANY_GET_BASIC_COMPANY_STRUCTURE,
  COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST,
  GET_CURRENT_USER_DRAG_AND_DROP,
  GET_CURRENT_USER_ID,
  GET_CURRENT_USER_RESIZE,
  GET_IS_CAPELO,
  GET_SECURITY_LEVEL
} from '@/store/getter-types'
import { CalendarEvent } from '@/model/planning/CalendarEvent'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { PlannedEmployee } from '@/model/planning/PlannedEmployee'
import { EditShiftPlan } from '@/model/planning/EditShiftPlan'
import { MESSAGING_SET_MESSAGES_DATA_MUTATION } from '@/store/mutation-types'
import { EmployeeCapacity } from '@/model/planning/EmployeeCapacity'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { DateHelper, Tooltip } from 'bryntum-scheduler'
import { Address } from '@/model/planning/Address'
import { Holiday } from '@/model/companyStructure/Holiday'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import MonthStatisticDialog from '@/components/planning/MonthStatisticDialog.vue'
import { getColorContrast } from '@/services/get-color-contrast'
import WarningDialog from '@/components/WarningDialog.vue'
import EmployeePlanningDetailDialog from '@/components/planning/EmployeePlanningDetailDialog.vue'
import NoteDialog from '@/components/planning/NoteDialog.vue'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import InvoicingDialog from '@/components/planning/InvoicingDialog.vue'
import { SchedulerSettings } from '@/model/planning/SchedulerSettings'
import AdditionalServicesDialog from '@/components/planning/AdditionalServicesDialog.vue'
import { NoteTooltip } from '@/model/planning/NoteTooltip'
import * as securityService from '@/services/security-service'
import { Invoice } from '@/model/planning/Invoice'
import CalendarEventEditor from '@/components/planning/calendar-event/CalendarEventEditor.vue'

let employeeEventListIndexedBySerieId: any = {}

interface ComponentData {
  drawer: boolean
  period: DatePeriodEnum
  companyStructure: CompanyStructure
  companyFilterValue: CompanyFilterValue
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  selectedTemplateItem: ShiftTemplate | undefined
  selectedCalendarEventItem: CalendarEvent | undefined

  isFastPlanningDisabled: boolean
  isFastPlanningActive: boolean
  isCalendarEventDisabled: boolean
  isCalendarEventActive: boolean
  currentPeriod: DatePeriod
  currentShift: PlannedShift | undefined
  shiftTemplateList: Array<ShiftTemplate>

  // filter configuration
  isShiftFilterByAddressActive: boolean
  showShiftWithSelectedAddress: number | undefined
  showOnlyEmployeesWithPlanning: boolean

  // data
  employeeResourceList: Array<EmployeeResource>
  employeeEventList: Array<EmployeeEvent>
  shiftList: Array<PlannedShift>
  timeRanges: Array<TimeRange>

  // scheduler
  schedulerPreset: Object
  schedulerColumns: Array<any>
  schedulerResources: Array<EmployeeResource>
  schedulerEvents: Array<EmployeeEvent>
  schedulerStartDate: Date
  schedulerEndDate: Date

  // sheduler
  groupFeature: string
  sortFeature: string
  stripeFeature: boolean
  scheduleTooltipFeature: boolean
  eventTooltipFeature: any
  timeRangesFeature: any
  resources: Array<any>
  events: Array<any>
  eventContextMenuFeature: any
  horizontalEventSorterFn: Function

  showShiftEditor: boolean
  shiftEditorPlanningPayload: ShiftEditorPlanningPayload | undefined
  calendarEventEditorPayload: ShiftEditorPlanningPayload | undefined
  calendarEventButtonInactive: boolean
  selectedShift: any
  selectedShiftForNote: any
  selectedCalendarEvent: any
  projectSerie: Array<EmployeeEvent>
  showDeleteDialog: boolean
  action: ActionsEnum | undefined
  selectedEmployeeList: PlannedEmployee[]
  isFixedShift: boolean
  editShift: EditShiftPlan | undefined
  showShiftEditDialog: boolean
  isEdittingShift: boolean
  isEdittingSerie: boolean
  selectedDetailId: number | null
  projectId: number | null
  checkedList: Array<CheckedShiftList>
  unselect: boolean
  toolbarFilterScope: number
  toolbarFilterSearchString: string | null
  filteredEmployees: Array<Employee>
  allowShiftDragAndDrop: boolean
  employeeCapacityList: Array<EmployeeCapacity>
  loading: boolean
  yearPeriodScrollDate: Date
  isYearPeriodChangeDate: boolean
  selectedTemplateId: number | undefined
  isEventTextOver: boolean
  projectSerieTemplate: ShiftTemplate | undefined
  editShiftAddressId: number | undefined
  allowShiftDelete: boolean
  selectedAddressItem: Address | undefined
  holidayList: Array<TimeRange>
  showMonthStatistic: boolean
  isMonthStatisticDisabled: boolean
  isAllDayLong: boolean
  showWarningDialog: boolean
  warningMessage: string
  dragAndResizeContext: any
  showEmployeePlanningDetailDialog: boolean
  planningDetailData: any | undefined
  isSelectProjectSerieActive: boolean
  showNoteDialog: boolean
  noteDialogTitle: string
  dialogNote: string
  noteSaveInProgress: boolean
  selectedEmployee: any
  selectedEmployeeForNote: any
  isEditShiftNoteDisabled: boolean
  isEditEmployeeNoteDisabled: boolean
  editNoteAction: NoteEditMenu
  showInvoicing: boolean
  schedulerSettings: SchedulerSettings[]
  isAdditionalServicesDisabled: boolean
  showAdditionalServices: boolean
  additionalServicesTitle: string
  additionalServicesAction: number | null
  filteredShiftList: PlannedShift[]
  showCompleteShiftWarningDialog: boolean
  completeShiftWarningMessage: string
  showActivateShiftWarningDialog: boolean
  activateShiftWarningMessage: string
  showDeactivateShiftWarningDialog: boolean
  deactivateShiftWarningMessage: string
  tooltipList: any
  showWeekPeriod: boolean
  invoicingDialogData: Invoice | undefined
  defaultCurrency: number | undefined
  showCalendarEventEditor: boolean
}

export default Vue.extend({
    name: 'PlanningPage',

    components: {
      CompanyFilter,
      ShiftList,
      SchedulerToolbar,
      Scheduler,
      ShiftEditor,
      DeleteDialog,
      ShiftEditDialog,
      ProgressCircular,
      MonthStatisticDialog,
      WarningDialog,
      EmployeePlanningDetailDialog,
      NoteDialog,
      InvoicingDialog,
      AdditionalServicesDialog,
      CalendarEventEditor
    },

    data (): ComponentData {
      const currentPeriod: DatePeriod = DatePeriod.createFromNow(DatePeriodEnum.Month)

      return {
        drawer: false,
        period: DatePeriodEnum.Month,
        showSnackbar: false,
        snackbarState: 0,
        messageSnackbar: '',
        selectedTemplateItem: undefined,
        selectedCalendarEventItem: undefined,
        companyStructure: {
          profitCenterList: [],
          departmentList: [],
          planningGroupList: [],
          employeeList: []
        },

        companyFilterValue: {
          profitCenter: undefined,
          department: undefined,
          planningGroup: undefined,
          employee: undefined
        },

        isFastPlanningDisabled: true,
        isFastPlanningActive: false,
        isCalendarEventDisabled: true,
        isCalendarEventActive: false,
        currentPeriod: currentPeriod,
        currentShift: undefined,
        shiftTemplateList: [],

        // filter configuration
        isShiftFilterByAddressActive: false,
        showShiftWithSelectedAddress: undefined,
        showOnlyEmployeesWithPlanning: false,

        // data
        employeeResourceList: [],
        employeeEventList: [],
        shiftList: [],

        // <editor-fold desc="Scheduler data & config">
        schedulerPreset: DatePeriodEnum.Month,
        schedulerColumns: [
          {
            text: 'Planungsgruppe',
            width: 150,
            field: 'planningGroupName',
            hidden: true
          },
          {
            text: 'Pos',
            width: 50,
            field: 'position',
            hidden: true
          },
          {
            text: this.$i18n.t('planningPage.employee'),
            width: 150,
            field: 'fullName',
            editor: false
          },
          {
            text: this.$i18n.t('planningPage.capacityShort'),
            width: 50,
            field: 'capacity',
            editor: false,
            hidden: true,
            align: 'end',
            htmlEncode : false,
            renderer({ value, record }: any) {
              if(record.capacityType === 2 || record.capacityType === 3) {
                return `<div style="background-color: #FFFDE7; height: 100%; width: 100%; position: relative;"><p style="margin: 0; position: absolute; right: 0; top: 50%; transform: translate(0, -50%)">${value}</p></div>`
              } else {
                return `<div style="height: 100%; width: 100%; position: relative;"><p style="margin: 0; position: absolute; right: 0; top: 50%; transform: translate(0, -50%)">${value}</p></div>`
              }
            }
          },
          {
            text: this.$i18n.t('planningPage.plan'),
            width: 50,
            field: 'plan',
            editor: false,
            hidden: true,
            align: 'end',
            htmlEncode : false
          },
          {
            text: 'IST',
            width: 50,
            field: 'IST',
            editor: false,
            hidden: true,
            align: 'end',
            htmlEncode : false
          },
          {
            text: 'MGAZ',
            width: 80,
            field: 'MGAZ',
            editor: false,
            hidden: true,
            align: 'end',
            htmlEncode : false,
            renderer({ value, record }: any) {
              if(value) {
                return `<div style="height: 100%; width: 100%; position: relative;"><p style="color: ${record.MGAZColor} !important; margin: 0; position: absolute; right: 0; top: 50%; transform: translate(0, -50%)">${value}</p></div>`
              } else {
                return `<div style="height: 100%; width: 100%; position: relative;"><p style="margin: 0; position: absolute; right: 0; top: 50%; transform: translate(0, -50%)">${value}</p></div>`
              }
            }
          },
          {
            text: 'Notiz',
            width: 100,
            field: 'note',
            editor: false,
            hidden: true,
            align: 'start',
            htmlEncode : false,
            renderer({ value, record }: any) {
              return `<div style="height: 100%; width: 100%; position: relative;"><p style="margin: 0; position: absolute; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;  right: 0; left: 0; top: 50%; transform: translate(0, -50%)">${value}</p></div>`
            }
          }
        ],
        schedulerResources: [],
        schedulerEvents: [],
        schedulerStartDate: currentPeriod.startDate,
        schedulerEndDate: currentPeriod.endDate,
        timeRanges: [],

        // scheduler
        groupFeature: 'planningGroupName',
        sortFeature: 'position',
        stripeFeature: true,
        scheduleTooltipFeature: false,
        eventTooltipFeature: undefined,
        timeRangesFeature: {
          showCurrentTimeLine : false,
          showHeaderElements  : false,
          enableResizing      : false
        },
        resources: [],
        events: [],
        eventContextMenuFeature: undefined,
        horizontalEventSorterFn: function(a: any, b: any) {
          const startA = moment(a.data.startDateOriginal).valueOf(), endA = moment(a.data.endDateOriginal).valueOf()
          const startB = moment(b.data.startDateOriginal).valueOf(), endB = moment(b.data.endDateOriginal).valueOf()

          const nameA = a.data.name ? a.data.name.toLowerCase() : a.data.name
          const nameB = b.data.name ? b.data.name.toLowerCase(): b.data.name

          const sameStart = (startA - startB === 0)
          const sameEnd = (endA - endB === 0)

          if (sameStart && !sameEnd) {
            return (endA < endB) ? -1 : 1
          } else if (sameStart && sameEnd) {
            return (nameA < nameB) ? -1 : 1
          } else {
            return (startA < startB) ? -1 : 1
          }
        },
        // </editor-fold>

        showShiftEditor: false,
        shiftEditorPlanningPayload: undefined,
        calendarEventEditorPayload: undefined,
        calendarEventButtonInactive: false,
        selectedShift: undefined,
        selectedShiftForNote: undefined,
        selectedCalendarEvent: undefined,
        projectSerie: [],
        showDeleteDialog: false,
        action: undefined,
        selectedEmployeeList: [],
        isFixedShift: false,
        editShift: undefined,
        showShiftEditDialog: false,
        isEdittingShift: false,
        isEdittingSerie: false,
        selectedDetailId: null,
        projectId: null,
        checkedList: [],
        unselect: false,
        toolbarFilterScope: 0,
        toolbarFilterSearchString: null,
        filteredEmployees: [],
        allowShiftDragAndDrop: false,
        employeeCapacityList: [],
        loading: false,
        yearPeriodScrollDate: moment().toDate(),
        isYearPeriodChangeDate: false,
        selectedTemplateId: undefined,
        isEventTextOver: false,
        projectSerieTemplate: undefined,
        editShiftAddressId: undefined,
        allowShiftDelete: false,
        selectedAddressItem: undefined,
        holidayList: [],
        showMonthStatistic: false,
        isMonthStatisticDisabled: false,
        isAllDayLong: false,
        showWarningDialog: false,
        warningMessage: '',
        dragAndResizeContext : undefined,
        showEmployeePlanningDetailDialog: false,
        planningDetailData: undefined,
        isSelectProjectSerieActive: false,
        showNoteDialog: false,
        noteDialogTitle: '',
        dialogNote: '',
        noteSaveInProgress: false,
        selectedEmployee: undefined,
        selectedEmployeeForNote: undefined,
        isEditShiftNoteDisabled: true,
        isEditEmployeeNoteDisabled: true,
        editNoteAction: NoteEditMenu.Shift,
        showInvoicing: false,
        schedulerSettings: [],
        isAdditionalServicesDisabled: false,
        showAdditionalServices: false,
        additionalServicesTitle: '',
        additionalServicesAction: null,
        filteredShiftList: [],
        showCompleteShiftWarningDialog: false,
        completeShiftWarningMessage: this.$i18n.t('planningPage.completeShiftWarningText').toString(),
        showActivateShiftWarningDialog: false,
        activateShiftWarningMessage: this.$i18n.t('planningPage.activateShiftWarningText').toString(),
        showDeactivateShiftWarningDialog: false,
        deactivateShiftWarningMessage: this.$i18n.t('planningPage.deactivateShiftWarningText').toString(),
        tooltipList: [],
        showWeekPeriod: false,
        invoicingDialogData: undefined,
        defaultCurrency: undefined,
        showCalendarEventEditor: false
      }
    },

    computed: {
      shouldUpdateData (): boolean {
        return false
      },
      snackbarColor (): boolean {
        return this.snackbarState === SnackbarStateEnum.Success
      },
      schedulerAutoHeight (): boolean {
        if (this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.xsOnly) {
          return true
        } else {
          return false
        }
      },

      securityLevel (): number | undefined {
        return this.$store.getters[GET_SECURITY_LEVEL]
      },

      currentUserId (): number | undefined {
        return this.$store.getters[GET_CURRENT_USER_ID]
      },

      currentUserDragAndDrop (): boolean {
        return this.$store.getters[GET_CURRENT_USER_DRAG_AND_DROP]
      },
      currentUserResize (): boolean {
        return this.$store.getters[GET_CURRENT_USER_RESIZE]
      },

      selectedDepartmentId (): number | undefined {
        return this.companyFilterValue.department ? this.companyFilterValue.department!.id : undefined
      },

      isCapelo (): boolean {
        return this.$store.getters[GET_IS_CAPELO]
      }
    },

    watch: {
      currentPeriod (newVal: DatePeriod): void {

        let data: any = this.getRouteData()

        data.currentPeriod = newVal
        this.$router.push({name: 'planning', query: { data: JSON.stringify(data) }})


        // @ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        if (this.period !== newVal.period) {
          if(newVal.period === DatePeriodEnum.WorkingWeek) {
            engine.setViewPreset(DatePeriodEnum.Week)
            this.period = newVal.period
          } else {
            engine.setViewPreset(newVal.period)
            this.period = newVal.period
          }
        }

        engine.setStartDate(newVal.startDate)
        engine.setEndDate(newVal.endDate)

        if(newVal.period === DatePeriodEnum.Year) {

          setTimeout(() => {
            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.columns.topColumns[3].hidden = true
            engine.columns.topColumns[4].hidden = true
            engine.columns.topColumns[5].hidden = true
            engine.scrollToDate(moment(this.yearPeriodScrollDate),
              {
                block: 'start'
              }
            )
          }, 0)
        } else {
          // @ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine
          const foundCapacitySettings: SchedulerSettings | undefined = this.schedulerSettings.find((item: SchedulerSettings) => item.code === 'CAP')
          engine.columns.topColumns[3].hidden = foundCapacitySettings ? !foundCapacitySettings.value : false
          const foundPlanSettings: SchedulerSettings | undefined = this.schedulerSettings.find((item: SchedulerSettings) => item.code === 'PLAN')
          engine.columns.topColumns[4].hidden = foundPlanSettings ? !foundPlanSettings.value : false
          const foundISTSettings: SchedulerSettings | undefined = this.schedulerSettings.find((item: SchedulerSettings) => item.code === 'ISTS')
          engine.columns.topColumns[5].hidden = foundISTSettings ? !foundISTSettings.value : false
        }
        this.setTimeRanges(newVal.startDate, newVal.endDate)
        this.updateDataSet()
      },

      selectedShift (newVal: any): void {
        this.isEditShiftNoteDisabled = !newVal
      },

      selectedEmployee (newVal: any): void {
        this.isEditEmployeeNoteDisabled = !newVal;
      },

    },

    methods: {
      async editNote (action: number): Promise<void> {
        this.dialogNote = ''
        if(action === NoteEditMenu.Shift) {
          this.selectedShiftForNote = this.selectedShift
          const response: string = await this.$store.dispatch(FETCH_SHIFT_NOTE, this.selectedShiftForNote.projectShiftDetailId)
          if(response) {
            this.dialogNote = response
          }
          const formattedDate: string = moment(this.selectedShiftForNote.startDate).format('DD.MM.YYYY')
          this.noteDialogTitle = `${formattedDate} / ${this.selectedShiftForNote.name}`
          this.showNoteDialog = true
          this.editNoteAction = NoteEditMenu.Shift
        } else if(action === NoteEditMenu.Address) {
          this.selectedShiftForNote = this.selectedShift
          const payload: AddressNotePayload = {
            id: this.selectedShiftForNote.addressNumber,
            date: moment(this.selectedShiftForNote.startDateOriginal).format('YYYY/MM/DD'),
            employeeId: this.selectedShiftForNote.responsibleId
          }
          const response: AddressNoteResponse = await this.$store.dispatch(FETCH_ADDRESS_NOTE, payload)
          if(response) {
            this.dialogNote = response.Bemerkung ? response.Bemerkung : ''
            this.noteDialogTitle = response.AdressLinie ? response.AdressLinie : ''
          }
          this.showNoteDialog = true
          this.editNoteAction = NoteEditMenu.Address
        } else if(action === NoteEditMenu.Employee) {
          this.selectedEmployeeForNote = this.selectedEmployee
          const response: string = await this.$store.dispatch(FETCH_EMPLOYEE_NOTE, this.selectedEmployeeForNote.id)
          if(response) {
            this.dialogNote = response
          }
          this.noteDialogTitle = this.selectedEmployeeForNote.fullName
          this.showNoteDialog = true
          this.editNoteAction = NoteEditMenu.Employee
        }
      },

      onNoteDialogClose (): void {
        this.selectedShiftForNote = undefined
        this.selectedEmployeeForNote = undefined
        this.showNoteDialog = false
      },

      async onNoteSaveClick (note: string): Promise<void> {
        let payload = undefined
        if(this.editNoteAction === NoteEditMenu.Shift) {
          payload = {
            id: this.selectedShiftForNote.projectShiftDetailId,
            note: note,
            action: this.editNoteAction
          }
        } else if(this.editNoteAction === NoteEditMenu.Address) {
          payload = {
            id: this.selectedShiftForNote.addressNumber,
            note: note,
            action: this.editNoteAction,
            date: moment(this.selectedShiftForNote.startDateOriginal).format('YYYY-MM-DD'),
            employeeId: this.selectedShiftForNote.responsibleId
          }
        } else if(this.editNoteAction === NoteEditMenu.Employee) {
          payload = {
            id: this.selectedEmployeeForNote.id,
            note: note,
            action: this.editNoteAction
          }
        }

        if(payload) {
          try {
            const response = await this.$store.dispatch(SAVE_SHIFT_ADDRESS_EMPLOYEE_NOTE, payload)
            if(response) {
              this.selectedShiftForNote = undefined
              this.selectedEmployeeForNote = undefined
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
              this.showSnackbar = true
            }
          } catch {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          } finally {
            this.showNoteDialog = false
          }
        }
      },

      async onInvoicingDialogShow (): Promise<void> {
        if(this.selectedDepartmentId) {
          const payload: InvoicePayload = {
            year: moment(this.currentPeriod.startDate).format('YYYY'),
            month: this.currentPeriod.number,
            department: this.selectedDepartmentId
          }

          try {
            this.loading = true
            const response: InvoiceResponse = await this.$store.dispatch(FETCH_INVOICING_DATA, payload)
            if (!response.IsError && !response.InvoicingInProgress) {
              const data: Invoice = Invoice.createFromResponse(response)
              this.invoicingDialogData = data
              this.showInvoicing = true
            }
          } catch (e) {
          } finally {
            this.loading = false
          }
        }
      },

      onInvoicingDialogClose (): void {
        this.showInvoicing = false
      },

      activateSelectProjectSerie (isSelectProjectSerieActive: boolean): void {
        this.isSelectProjectSerieActive = isSelectProjectSerieActive
      },

      yearPeriodChangeDate (date: string): void {
        this.isYearPeriodChangeDate = true
        this.yearPeriodScrollDate = moment(date, "YYYY-MM-DD").toDate()
        // @ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        engine.scrollToDate(moment(date, "YYYY-MM-DD").toDate(),
          {
            block: 'start'
          }
        )
        setTimeout(() => { this.isYearPeriodChangeDate = false}, 1000)
      },

      horizontalScroll (data: any) {
        if(this.period === DatePeriodEnum.Year && !this.isYearPeriodChangeDate) {
          const number = Math.floor((data.scrollLeft)/50 )
          const selectedYear = moment(this.yearPeriodScrollDate).format('YYYY')
          const start = moment(selectedYear).startOf('year')
          this.yearPeriodScrollDate = moment(start).add(number, 'day').toDate()
        }
      },

      filterScopeChange (item: number): void {
        this.toolbarFilterScope = item
        this.filterScheduler()
      },

      filterSearchString (item: any): void {
        this.toolbarFilterSearchString = item
        this.filterScheduler()
      },

      async fetchFilterData (payload: PlaningFilterPayload): Promise<void> {
        try {
          const response: GetPlaningFilterData = await this.$store.dispatch(FETCH_PLANING_FILTER, payload)
          if(!response.IsError && response.Data) {
            let filteredEmployeeList: EmployeeResource[] = []
            if(payload.i_SearchString !== 'EMPTY_STRING') {
              if (response.Data.ds02) {
                response.Data.ds02.forEach((item: any) => {
                  const foundEmployee: EmployeeResource | undefined = this.employeeResourceList.find((i: EmployeeResource) => i.id === item.Mitarbeiter)
                  if (foundEmployee) {
                    filteredEmployeeList.push(foundEmployee)
                  }
                })
              }

              filteredEmployeeList = _.orderBy(filteredEmployeeList, ['fullName'], ['asc'])
            } else {
              filteredEmployeeList = this.employeeResourceList
            }

            if (this.showOnlyEmployeesWithPlanning) {
              let employeeList: EmployeeResource[] = filteredEmployeeList.filter((item: EmployeeResource) => {
                return item.eventList.find((i: EmployeeEvent) => {
                  if(i.type === 'absence' || i.type === 'calendar') {
                    return true
                  } else {
                    return response.Data.ds01.find((s: any) => s.Shift === i.projectShiftDetailId)
                  }
                })
              })
              if (this.employeeCapacityList.length > 0) {
                this.schedulerResources = EmployeeResource.createListWithCapacity(employeeList, this.employeeCapacityList)
              } else {
                this.schedulerResources = employeeList
              }
            } else {
              if (this.employeeCapacityList.length > 0) {
                this.schedulerResources = EmployeeResource.createListWithCapacity(filteredEmployeeList, this.employeeCapacityList)
              } else {
                this.schedulerResources = filteredEmployeeList
              }
            }

            //@ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.eventStore.clearFilters()
            engine.eventStore.filterBy((event: any) => {
              if ((event.type === 'shift' || event.type === 'originalShift') && response.Data.ds01) {
                if(this.showShiftWithSelectedAddress) {
                  return event.addressId === this.showShiftWithSelectedAddress && !!response.Data.ds01.find((i: any) => i.Shift === event.projectShiftDetailId)
                } else {
                  return !!response.Data.ds01.find((i: any) => i.Shift === event.projectShiftDetailId)
                }

              } /*else if (event.type === 'absence' && response.Data.ds03) {
                return !!response.Data.ds03.find((i: any) => i.AbsenceID === event.absenceId)
              } else if (event.type === 'calendar' && response.Data.ds04) {
                return !!response.Data.ds04.find((i: any) => i.ID === event.kaId)
              }*/ else {
                return true
              }
            })

            let list: PlannedShift[] = []
            this.shiftList.forEach((i: PlannedShift) => {
              const foundItem: EmployeeEvent | undefined = engine.eventStore.find((item: EmployeeEvent) => item.projectSerieId === i.projectSerie)
              if (foundItem) {
                list.push(i)
              }
            })
            this.filteredShiftList = list
          }
        } catch {
        }
      },

      filterScheduler (): void {
        // @ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        engine.clearEventSelection()
        this.selectedShift = undefined
        this.projectSerie = []
        this.checkedList = []

        if(this.toolbarFilterSearchString || this.toolbarFilterScope !== ShiftFilterScope.AllShifts) {
          let status = 'alle'
          if(this.toolbarFilterScope === ShiftFilterScope.AllShifts) {
            status = 'alle'
          } else if(this.toolbarFilterScope === ShiftFilterScope.FixedShifts) {
            status = 'fixiert'
          } else if(this.toolbarFilterScope === ShiftFilterScope.TemporaryShifts) {
            status = 'provisorisch'
          } else if(this.toolbarFilterScope === ShiftFilterScope.Active) {
            status = 'aktiv'
          } else if(this.toolbarFilterScope === ShiftFilterScope.Inactive) {
            status = 'inaktiv'
          } else if(this.toolbarFilterScope === ShiftFilterScope.Closed) {
            status = 'abgeschlossen'
          } else if(this.toolbarFilterScope === ShiftFilterScope.Invoiced) {
            status = 'verrechnet'
          }

          if(this.companyFilterValue.department && this.companyFilterValue.profitCenter) {
            const payload: PlaningFilterPayload = {
              i_SearchString: this.toolbarFilterSearchString ? this.toolbarFilterSearchString : 'EMPTY_STRING',
              i_Status: status,
              i_Abt: this.companyFilterValue.department!.id,
              i_FirstDate: this.currentPeriod.formattedStartDate('YYYY-MM-DD'),
              i_LastDate: this.currentPeriod.formattedEndDate('YYYY-MM-DD'),
              i_Pfc: this.companyFilterValue.profitCenter!.id
            }

            this.fetchFilterData(payload)
          }
        } else {
          //@ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine
          engine.eventStore.clearFilters()

          if(this.showShiftWithSelectedAddress) {
            engine.eventStore.filterBy((event: any) => {
              if((event.type === 'shift' || event.type === 'originalShift')) {
                return event.addressId === this.showShiftWithSelectedAddress
              } else {
                return true
              }
            })

            let list: PlannedShift[] = []
            this.shiftList.forEach((i: PlannedShift) => {
              const foundItem: EmployeeEvent | undefined = engine.eventStore.find((item: EmployeeEvent) => item.projectSerieId === i.projectSerie)
              if (foundItem) {
                list.push(i)
              }
            })
            this.filteredShiftList = list
          } else {
            this.filteredShiftList = this.shiftList
          }

          if (this.showOnlyEmployeesWithPlanning) {
            if (this.employeeCapacityList.length > 0) {
              this.schedulerResources = EmployeeResource.createListWithCapacity(this.employeeResourceList.filter((item: EmployeeResource) => !item.hasEmptySchedule), this.employeeCapacityList)
            } else {
              this.schedulerResources = this.employeeResourceList.filter((item: EmployeeResource) => !item.hasEmptySchedule)
            }
          } else {
            if (this.employeeCapacityList.length > 0) {
              this.schedulerResources = EmployeeResource.createListWithCapacity(this.employeeResourceList, this.employeeCapacityList)
            } else {
              this.schedulerResources = this.employeeResourceList
            }
          }
        }
      },

      disableEdit (item: Array<CheckedShiftList>): void {
        this.selectedCalendarEvent = undefined
        // @ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        engine.clearEventSelection()
        this.checkedList = item
        this.unselect = false
      },
      // <editor-fold desc="Event handlers">
      onFilterValueChanged (payload: CompanyFilterValue): void {
        this.defaultCurrency = payload.profitCenter ? payload.profitCenter.reserveCurrency : undefined
        this.companyFilterValue = payload

        this.updateDataSet()
        this.calendarEventButtonInactive = !this.calendarEventButtonInactive
      },

      onShiftSelected (item: PlannedShift): void {
        if (item) {
          this.currentShift = item
          // @ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine
          const newProjectSerie: Array<EmployeeEvent> = this.schedulerEvents.filter((i: EmployeeEvent) => i.projectSerieId === item.projectSerie)
          let numberOfShift: number = 0
          if (newProjectSerie !== this.projectSerie) {
            this.projectSerie = newProjectSerie
          }

          if(this.isSelectProjectSerieActive || !this.selectedShift) {

            this.projectSerie.forEach((item: EmployeeEvent) => {
              if (numberOfShift === 0) {
                const foundItem: any = engine.eventStore.getById(item.id)
                engine.selectEvent(foundItem)
                numberOfShift++
              } else if (numberOfShift > 0 && numberOfShift < this.projectSerie.length) {
                const foundItem: any = engine.eventStore.getById(item.id)
                engine.selectEvent(foundItem, true)
              } else if (numberOfShift === this.projectSerie.length) {
                const foundItem: any = engine.eventStore.getById(item.id)
                engine.selectEvent(foundItem)
                numberOfShift++
              }
            })
          } else {
            const foundEvent: EmployeeEvent | undefined = this.projectSerie.find((i: EmployeeEvent) => i.projectShiftDetailId === this.selectedShift.projectShiftDetailId)
            if(foundEvent) {
              const foundItem: any = engine.eventStore.getById(foundEvent.id)
              engine.selectEvent(foundItem)
            }
          }
        } else {
          // @ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine
          engine.clearEventSelection()
          this.selectedShift = undefined
        }
      },

      onSchedulerSelect (e: any): void {
        if (e && e.selection[0] && e.selection[0].data) {

          const floaterEvents: Array<number> = []
          this.employeeEventList.forEach((item: EmployeeEvent) => {
            if (this.companyFilterValue.department && item.department != this.companyFilterValue.department.id) {
              floaterEvents.push(item.id)
            }
          })

          if (e.selection[0].data.type === 'shift') {
            if (floaterEvents.includes(e.selection[0].data.id)) {
              this.selectedShift = undefined
              this.selectedCalendarEvent = undefined
            } else {
              this.selectedShift = e.selection[0].data
              this.selectedCalendarEvent = undefined
            }
          } else if (e.selection[0].data.type === 'calendar') {
            this.unselect = true
            this.selectedShift = undefined
            this.selectedCalendarEvent = e.selection[0].data

            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.clearEventSelection()
          } else if (e.selection[0].data.type === 'floater') {
            this.unselect = true
            this.selectedShift = undefined
            this.selectedCalendarEvent = undefined

            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.clearEventSelection()
          } else if (e.selection[0].data.type === 'absence') {
            this.unselect = true
            this.selectedShift = undefined
            this.selectedCalendarEvent = undefined

            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.clearEventSelection()
          }

          if(this.checkedList.length > 0) {
            this.checkedList = []
          }
        }
      },

      hasSatisfySchedule (list: Array<PlannedShift>, item: EmployeeResource): boolean {
       if(item.eventList.find((event: EmployeeEvent) => {
          return list.some((shift: PlannedShift) => {
            return shift.projectSerie === event.projectSerieId
          })
        })) {
         return true
       } else {
         return false
       }
      },

      onPeriodSelected (period: DatePeriod): void {
        this.loading = true
        this.currentPeriod = period

        if(this.currentPeriod.period === 'month') {
          this.isMonthStatisticDisabled = false
        } else {
          this.isMonthStatisticDisabled = true
        }

        if(this.currentPeriod.period === 'year') {
          this.showAdditionalServices = false
          this.isAdditionalServicesDisabled = true
        } else {
          this.isAdditionalServicesDisabled = false
        }

        this.employeeCapacityList = []
        this.schedulerResources = EmployeeResource.createListWithEmptyCapacity(this.schedulerResources)
      },

      onShowMonthStatistic (value: boolean): void {
        this.showMonthStatistic = value
      },

      onMonthStatisticDialogClose (): void {
        this.showMonthStatistic = false
      },

      onShowShiftWithSelectedAddress (value: boolean): void {
        this.isShiftFilterByAddressActive = value
        if(value) {
          this.showShiftWithSelectedAddress = this.selectedAddressItem!.id
        } else {
          this.showShiftWithSelectedAddress = undefined
        }

        this.filterScheduler()
      },

      onNewPlanCreated (): void {
        this.closeShiftEditor()
        this.updateDataSet()
      },

      shiftPlanEdited (): void {
        this.closeShiftEditor()
        this.updateDataSet()
        this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
      },

      shiftPlanEditedFalse (): void {
        this.closeShiftEditor()
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      },

      beforeDragCreateFinalize (context: any): void {
        context.context.async = true
        if(this.allowShiftDragAndDrop) {
          context.context.finalize(true)
        } else {
          context.context.finalize(false)
        }
      },

      onManualShiftCreate (data: { newEventRecord: { startDate: Date, endDate: Date, name: string | undefined }, resourceRecord: EmployeeResource }): void {
        data.newEventRecord.name = this.$t('planningPage.manualPlan').toString()
        const planningDetailsPayload: PlanningDetailsPayload[] = [{
          SchichtID: null,
          ProjektSerie: 0,
          datumStart: moment(data.newEventRecord.startDate).format('YYYY/MM/DD HH:mm'),
          datumEnde: moment(data.newEventRecord.endDate).format('YYYY/MM/DD HH:mm'),
          MitarbeiterID: data.resourceRecord.id,
          NotizElement: "",
          ArbeitID: null,
          fixiert: false,
          number: 1,
          Abteilung: this.companyFilterValue.department!.id,
          Zeile: 1
        }]

        const newShiftPayload: CreateShiftPayload = {
          Action: "",
          SchichtName: "",
          ProfitCenter: this.companyFilterValue.profitCenter!.id,
          Abteilung: this.companyFilterValue.department!.id,
          Sachbearbeiter: this.currentUserId!,
          ReferenzTermin: moment(data.newEventRecord.startDate).format('YYYY/MM/DD HH:mm'),
          Montag: false,
          Dienstag: false,
          Mittwoch: false,
          Donnerstag: false,
          Freitag: false,
          Samstag: false,
          Sonntag: false,
          Whlg: 0,
          Einmalig: true,
          Sprache: this.$store.state.selectedUiLanguage!.syzId,
          EndAfternTimes: null,
          EndAfterDate: null,
          Provisorich: true,
          Fixiert: false,
          Notiz: "",
          DatumStart: moment(data.newEventRecord.startDate).format('YYYY/MM/DD HH:mm'),
          DatumEnde: moment(data.newEventRecord.endDate).format('YYYY/MM/DD HH:mm'),
          SchichtID: null,
          AdressID: this.selectedAddressItem ? this.selectedAddressItem.id : null,
          Zusatzfelder: [],
          PlanningDetails: planningDetailsPayload
        }

        this.manualShiftCreate(newShiftPayload)
      },

      async manualShiftCreate (payload: CreateShiftPayload): Promise<void> {
        try {
          this.loading = true
          const response: CreateShiftNewResponse = await this.$store.dispatch(CREATE_SHIFT_NEW, { newShiftPayload: payload })
          this.loading = false
          if(response && !response.IsError) {
            this.updateDataSet()
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      },

      onSchedulerEventDrop (event: any): void {
        const data: any = event.eventRecords[0]
        let startDate =  moment(data.data.startDate).format('YYYY-MM-DD HH:mm')
        let endDate = moment(data.data.endDate).format('YYYY-MM-DD HH:mm')

        if(this.isAllDayLong) {
          if(moment(data.data.endDateOriginal).isAfter(moment(data.data.startDateOriginal), 'day')) {
            startDate = `${moment(data.data.startDate).format('YYYY-MM-DD')} ${moment(data.data.startDateOriginal).format('HH:mm')}`
            endDate = `${moment(data.data.startDate).add(1, 'days').format('YYYY-MM-DD')} ${moment(data.data.endDateOriginal).format('HH:mm')}`
          } else {
            startDate = `${moment(data.data.startDate).format('YYYY-MM-DD')} ${moment(data.data.startDateOriginal).format('HH:mm')}`
            endDate = `${moment(data.data.startDate).format('YYYY-MM-DD')} ${moment(data.data.endDateOriginal).format('HH:mm')}`
          }
        }

        const payload: EventDropPayload = {
          projectShiftDetailId: data.data.projectShiftDetailId,
          employeeId: data.resourceId,
          startDate: startDate,
          endDate: endDate,
          isDrag: 1
        }
        this.eventDragSave(payload)
      },

      onSchedulerEventResizeEnd (event: any): void {
        if(event.changed) {
          const data: any = event.eventRecord.data
          const payload: EventDropPayload = {
            projectShiftDetailId: data.projectShiftDetailId,
            employeeId: data.employeeId,
            startDate: moment(data.startDate).format('YYYY-MM-DD HH:mm'),
            endDate: moment(data.endDate).format('YYYY-MM-DD HH:mm'),
            isDrag: 0
          }
          this.eventDragSave(payload)
        }
      },

      async eventDragSave (payload: EventDropPayload): Promise<void> {
        this.loading = true
        try {
          const data: ResponseBase = await this.$store.dispatch(EVENT_DRAG_SAVE, payload)
          if (!data.IsError) {
            this.updateDataSet()
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
            this.snackbarState = SnackbarStateEnum.Success
          } else {
            this.updateDataSet()
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          }
        } catch (e) {
          this.updateDataSet()
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
        }
        this.showSnackbar = true
      },

      beforeEventDropFinalize (context: any): void {
        context.context.async = true;
        if(this.currentUserDragAndDrop) {
          this.warningMessage = this.$t('planningPage.dragAndDropWarningMessage').toString()
          this.showWarningDialog = true
          this.dragAndResizeContext = context.context
        } else {
          context.context.finalize(true)
        }
      },

      beforeEventResizeFinalize (context: any): void {
        context.context.async = true;
        if(this.currentUserResize) {
          this.warningMessage = this.$t('planningPage.resizeWarningMessage').toString()
          this.showWarningDialog = true
          this.dragAndResizeContext = context.context
        } else {
          context.context.finalize(true)
        }
      },

      onWarningDialogClose (): void {
        this.dragAndResizeContext.finalize(false)
        this.dragAndResizeContext = undefined
        this.showWarningDialog = false
      },

      onWarningDialogSave (): void {
        this.dragAndResizeContext.finalize(true)
        this.dragAndResizeContext = undefined
        this.showWarningDialog = false
      },

      onCloseEditor (): void {
        this.closeShiftEditor()
      },

      onAddNewEmptyShift (): void {
        this.action = ActionsEnum.CREATE
        this.editShift = undefined
        this.shiftEditorPlanningPayload = ShiftEditorPlanningPayload.create(
          [],
          EventTimePeriod.createDefaultRange(),
          this.companyStructure,
          this.companyFilterValue
        )
        this.isFixedShift = false
        this.showShiftEditor = true
      },

      onEditShiftClick (): void {
        this.fetchEditShift(this.selectedShift.projectSerieId).then(() => {
          if (this.editShift && this.editShift.unique === '0') {
            //this.showShiftEditDialog = true
            if(this.isSelectProjectSerieActive) {
              this.isEdittingSerie = true
              this.isEdittingShift = false
              this.openEditStepper()
            } else {
              this.isEdittingSerie = false
              this.isEdittingShift = true
              this.openEditStepper()
            }
          } else {
            this.isEdittingSerie = false
            this.isEdittingShift = false
            this.openEditStepper()
          }
        })
      },

      openEditStepper (): void {
        if (this.editShift) {
          this.action = ActionsEnum.EDIT
          this.fetchShiftTemplateList()
          const sortedDetails = _.sortBy(this.editShift.details, ['dateStart'])

          let start = moment(sortedDetails[0].dateStart).format('YYYY-MM-DD')
          let timeStart = moment(this.editShift.dateStart).format('HH:mm')
          let end = moment(sortedDetails[0].dateEnd).format('YYYY-MM-DD')
          let timeEnd = moment(this.editShift.dateEnd).format('HH:mm')

          if(this.isEdittingShift) {
            const foundDetail: ShiftEmployeeDetails | undefined = this.editShift.details.find((detail: ShiftEmployeeDetails) => detail.detailId === this.selectedShift.projectShiftDetailId)

            if(foundDetail) {
              start = moment(foundDetail.dateStart).format('YYYY-MM-DD')
              timeStart = moment(foundDetail.dateStart).format('HH:mm')
              end = moment(foundDetail.dateEnd).format('YYYY-MM-DD')
              timeEnd = moment(foundDetail.dateEnd).format('HH:mm')
            }
          }

          const startDate = moment(`${start} ${timeStart}`, 'YYYY-MM-DD HH:mm').toDate()
          const endDate = moment(`${end} ${timeEnd}`, 'YYYY-MM-DD HH:mm').toDate()

          this.shiftEditorPlanningPayload = ShiftEditorPlanningPayload.edit(
            [],
            EventTimePeriod.editRange(startDate, endDate),
            this.companyStructure,
            this.companyFilterValue
          )

          this.showShiftEditor = true
        }
      },

      async fetchShiftTemplateList (): Promise<void> {
        this.shiftTemplateList = await this.$store.dispatch(LOAD_SHIFT_TEMPLATE_LIST, { departmentId: this.companyFilterValue.department!.id })
        const foundShift: PlannedShift | undefined = this.shiftList.find((item: PlannedShift) => item.projectId === this.editShift!.projectId)
        if (foundShift) {
          this.editShiftAddressId = foundShift.addressId ? foundShift.addressId : undefined
          const templateItem: ShiftTemplate = _.find(this.shiftTemplateList, { id: foundShift.shift })! as ShiftTemplate
          this.$store.dispatch(PLANNING_ASSISTANT_SET_SHIFT_TEMPLATE_ITEM, templateItem)
        } else {
          const foundShift: PlannedShift | undefined = this.shiftList.find((item: PlannedShift) => item.projectSerie === this.editShift!.projectSerieId)
          if (foundShift) {
            this.projectSerieTemplate = _.find(this.shiftTemplateList, { id: foundShift.shift })! as ShiftTemplate
            this.editShiftAddressId = foundShift.addressId ? foundShift.addressId : undefined
          }
        }
      },

      async fetchEditShift (item: number): Promise<void> {
        const data: Array<EditShiftPlan> = await this.$store.dispatch(FETCH_EDIT_SHIFT, item)
        this.editShift = data[0]
      },

      onDeleteShiftClick (): void {
        //@ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        if(engine.selectedEvents.length === 1 && !this.isSelectProjectSerieActive || this.selectedCalendarEvent) {
          this.showDeleteDialog = true
        }
      },

      onDeleteDialogClose (): void {
        this.showDeleteDialog = false
      },

      onDeleteDialogSave (): void {
        if (this.selectedShift && this.securityLevel !== 7) {
          // @ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine
          if(engine.selectedEvents.length > 1) {
            this.deleteShiftSerie()
            this.loading = true
          } else {
            this.deleteShift()
          }
        } else if (this.selectedCalendarEvent) {
          if(this.securityLevel !== 7) {
            this.deleteCalendarEvent()
            this.loading = true
          } else {
            if(this.selectedCalendarEvent.category === 2 && this.currentUserId === this.selectedCalendarEvent.employeeId) {
              this.deleteCalendarEvent()
              this.loading = true
            }
          }
        } else if (this.checkedList && this.securityLevel !== 7) {
          this.deleteCheckedList()
          this.loading = true
        }
        this.showDeleteDialog = false
      },

      async deleteShift (): Promise<void> {
        try {
          await this.$store.dispatch(DELETE_SHIFT, this.selectedShift.projectShiftDetailId)
          this.updateDataSet()
          this.messageSnackbar = this.$t('planningPage.shiftHasBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
        } catch (e) {
          this.messageSnackbar = this.$t('planningPage.shiftCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
        this.showSnackbar = true
      },

      async deleteShiftSerie (): Promise<void> {
        try {
          await this.$store.dispatch(DELETE_PROJECT_SERIEN, this.selectedShift.projectSerieId)
          this.updateDataSet()
          this.messageSnackbar = this.$t('planningPage.shiftHasBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
        } catch (e) {
          this.messageSnackbar = this.$t('planningPage.shiftCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
        }
        this.showSnackbar = true
      },

      async deleteCheckedList (): Promise<void> {
        if (this.checkedList) {
          let payload: Array<number> = []
          this.checkedList.forEach((item: CheckedShiftList) => {
            payload.push(item.projectSerie)
          })
          try {
            await this.$store.dispatch(DELETE_CHECKED_LIST, payload)
            this.updateDataSet()
            this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
            this.snackbarState = SnackbarStateEnum.Success
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
          }
          this.showSnackbar = true
        }
      },

      onActivateFastPlanning (isActive: boolean): void {
        this.isFastPlanningActive = isActive
      },

      onActivateCalendarEvent (isActive: boolean): void {
        this.isCalendarEventActive = isActive
      },

      openCalendarEventStepper (): void {
        this.action = ActionsEnum.CREATE
        this.calendarEventEditorPayload = ShiftEditorPlanningPayload.create(
            [],
            EventTimePeriod.createDefaultRange(),
            this.companyStructure,
            this.companyFilterValue
        )
        this.showCalendarEventEditor = true
      },

      calendarEventStepperSuccess (item: string): void {
        this.closeCalendarEventStepper()
        this.messageSnackbar = item
        this.snackbarState = SnackbarStateEnum.Success
        this.showSnackbar = true
        this.updateDataSet()
      },

      calendarEventStepperError (item: string): void {
        this.closeCalendarEventStepper()
        this.messageSnackbar = item
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      },

      closeCalendarEventStepper (): void {
        this.showCalendarEventEditor = false
        this.calendarEventEditorPayload = undefined
        this.action = undefined
      },

      onTemplateSelect (templateItem: ShiftTemplate): void {
        if (templateItem) {
          this.selectedTemplateItem = templateItem
          this.isFastPlanningDisabled = false
          this.selectedTemplateId = templateItem.id
        } else {
          this.selectedTemplateItem = undefined
          this.isFastPlanningDisabled = true
          this.selectedTemplateId = undefined
        }
      },

      onCalendarEventSelect (calendarEventItem: CalendarEvent): void {
        if (calendarEventItem) {
          this.selectedCalendarEventItem = calendarEventItem
          this.isCalendarEventDisabled = false
        } else {
          this.selectedCalendarEventItem = undefined
          this.isCalendarEventDisabled = true
        }
      },

      omSelectedAddress (addressItem: Address) : void {
        if (addressItem) {
          if(this.isShiftFilterByAddressActive) {
            this.showShiftWithSelectedAddress = addressItem.id
            this.filterScheduler()
          } else {
            this.showShiftWithSelectedAddress = undefined
          }
          this.selectedAddressItem = addressItem
        } else {
          this.selectedAddressItem = undefined
        }
      },

      async onScheduleClick (item: { source: any, date: Date, row: any, index: number, resourceRecord: any, event: MouseEvent }): Promise<any> {
        if (this.isFastPlanningActive && this.selectedTemplateItem && this.isEmployeeResource(item.resourceRecord.data)) {
          this.loading = true
          const rowNumber = 1
          const employeeId: number = item.resourceRecord.data.id
          const profitCenter = this.companyFilterValue.profitCenter!.id
          const department = this.companyFilterValue.department!.id
          const periodicity: PlanningAssistantPeriodicityPayload = {
            isUnique: true,
            weekDayList: [],
            repeatEveryNthWeek: 1,
            expireAfterRepetitions: 0,
            expireAfterDate: undefined
          }
          const dateStart = moment(item.date)
            .hour(this.selectedTemplateItem.startDate.getHours())
            .minute(this.selectedTemplateItem.startDate.getMinutes())
            .second(0)

          const dateEnd = moment(item.date)
            .hour(this.selectedTemplateItem.endDate.getHours())
            .minute(this.selectedTemplateItem.endDate.getMinutes())
            .second(0)

          const planningDetails: PlanningDetailsPayload[] = planningService.composeAddEmployeeToShiftPayloadForFastPlanning(
              this.selectedTemplateItem,
              ShiftAvailability.Temporary,
              rowNumber,
              employeeId,
              item.date,
              department)

          const newShiftPayload: CreateShiftPayload = planningService.composeCreateNewShiftPayload(
            profitCenter,
            department,
            this.$store.state.currentUser!.id,
            this.$store.state.selectedUiLanguage!.syzId,
            dateStart.toDate(),
            dateEnd.toDate(),
            periodicity,
            ShiftAvailability.Temporary,
            this.selectedTemplateItem,
            this.selectedAddressItem ? this.selectedAddressItem.id : null,
            [],
            []
          )

          newShiftPayload.PlanningDetails = planningDetails

          const newShiftData: CreateShiftNewResponse = await this.$store.dispatch(CREATE_SHIFT_NEW, {
            newShiftPayload: newShiftPayload, isFastPlanning: true
          })

          if (newShiftData && newShiftData.ProjectSeriesId) {
            this.updateDataSet()
            this.messageSnackbar = this.$t('planningPage.workerAddedToShiftSuccess')
            this.snackbarState = SnackbarStateEnum.Success
          } else {
            this.messageSnackbar = this.$t('planningPage.workerAddedToShiftError')
            this.snackbarState = SnackbarStateEnum.Error
          }
          this.showSnackbar = true
          this.loading = false
        } else if (this.isCalendarEventActive && this.selectedCalendarEventItem && this.isEmployeeResource(item.resourceRecord.data)) {

          if(this.securityLevel === 7 && (this.selectedCalendarEventItem.eventId !== 2 || item.resourceRecord.data.id !== this.currentUserId)) return

          this.loading = true
          const employeeId: number = item.resourceRecord.data.id

          const dateStart = moment(item.date)
            .hour(0)
            .minute(0)
            .second(0)

          const dateEnd = moment(item.date)
            .hour(23)
            .minute(59)
            .second(59)

          const newCalendarEventPayload: CreateCalendarEventPayload = {
            eventId: this.selectedCalendarEventItem.eventId,
            eventName: this.selectedCalendarEventItem.eventName,
            employeeId: employeeId,
            dateStart: moment(dateStart).format('YYYY-MM-DD HH:mm:ss'),
            dateEnd: moment(dateEnd).format('YYYY-MM-DD HH:mm:ss'),
            language: this.$store.state.selectedUiLanguage!.syzId,
          }

          try {
            const response = await this.$store.dispatch(INSERT_CALENDAR_ART, newCalendarEventPayload)

            if (response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('planningPage.calendarEventSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.updateDataSet()
              this.messageSnackbar = this.$t('planningPage.failedToSaveCalendarEvent')
              this.snackbarState = SnackbarStateEnum.Error
            }
            this.showSnackbar = true
          } catch (e) {
            this.updateDataSet()
            this.messageSnackbar = this.$t('planningPage.failedToSaveCalendarEvent')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        }
      },

      async deleteCalendarEvent (): Promise<any> {
        if (this.selectedCalendarEvent) {
          const deleteCalendarEventPayload: DeleteCalendarEventPayload = {
            id: this.selectedCalendarEvent.kaId,
            eventId: 0,
            employeeId: this.selectedCalendarEvent.employeeId,
            dateStart: moment(this.selectedCalendarEvent.startDate).format('YYYY-MM-DD HH:mm:ss'),
            dateEnd: moment(this.selectedCalendarEvent.endDate).format('YYYY-MM-DD HH:mm:ss'),
            language: this.$store.state.selectedUiLanguage!.syzId
          }

          try {
            const response = await this.$store.dispatch(DELETE_CALENDAR_ART, deleteCalendarEventPayload)

            if (response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('planningPage.calendarEventHasBeenDeleted')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.updateDataSet()
              this.messageSnackbar = this.$t('planningPage.calendarEventCouldNotBeDeleted')
              this.snackbarState = SnackbarStateEnum.Error
            }
            this.showSnackbar = true
          } catch (e) {
            this.updateDataSet()
            this.messageSnackbar = this.$t('planningPage.calendarEventCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        }
      },

      isEmployeeResource (selectedItem: any): selectedItem is EmployeeResource {
        return selectedItem.type === SchedulerResourceEnum.Employee
      },
      // </editor-fold>

      // <editor-fold desc="Data loading">
      async fetchEventList (): Promise<Array<EmployeeEvent>> {

        let view: ViewEnum = ViewEnum.TimelineMonth
        if (this.period === DatePeriodEnum.Week) {
          view = ViewEnum.TimelineWeek
        } else if (this.period === DatePeriodEnum.Day) {
          view = ViewEnum.Day
        } else if (this.period === DatePeriodEnum.Year) {
          view = ViewEnum.TimelineYear
        } else if (this.period === DatePeriodEnum.WorkingWeek) {
          view = ViewEnum.TimelineWorkDaysWeek
        }

        const payload: PlanPayload = {
          profitCenterId: this.companyFilterValue.profitCenter!.id,
          departmentId: this.companyFilterValue.department!.id,
          calendarDate: this.currentPeriod.formattedStartDate('DD/MM/YYYY'),
          view: view
        }

        const data: PlanResponse = await this.$store.dispatch(LOAD_PLAN, payload)

        const events: PlanResponse = []
        if(data) {
          data.forEach((item: PlanItem) => {
            if (this.companyFilterValue.department && item.Abteilung != this.companyFilterValue.department.id && item.type === 'shift') {
              item.type = 'floater'
              item.style = 'background-color: lightgray; color: white!important;'
            } else if (item.type === 'originalShift') {
              item.style = 'background-color: lightgray; color: white!important;'
            } else if (item.STV === 1 && item.Status !== 'inaktiv') {
              const contrastColor: string | undefined = item.color === '#ffffff' || item.color === '#fffaed' || item.color === '#fff' ? '#000' : undefined
              item.style = `background-image: repeating-linear-gradient(135deg, ${item.color}, ${item.color} 5px, ${contrastColor ? contrastColor : '#fff'} 5px, ${contrastColor ? contrastColor : '#fff'} 10px); color: black !important`
            } else if (item.STV === 1 && item.Status === 'inaktiv') {
              item.style = `background-image: repeating-linear-gradient(135deg, lightgray, lightgray 5px, #fff 5px, #fff 10px); color: white !important`
            } else if (item.STV !== 1 && item.Status === 'inaktiv') {
              item.style = 'background-color: lightgray; color: white!important;'
            } else {
              const textColor: string = getColorContrast(item.color)
              item.style = `color: ${textColor}!important;`
            }

            if (item.mitabeiterID == null && item.type === 'shift') {
              item.mitabeiterID = 0
            }

            events.push(item)
          })
        } else {
          this.loading = false
        }

        if(this.isAllDayLong && this.period === DatePeriodEnum.Day && events && events.length !== 0) {
          // @ts-ignore
          const engine = this.$refs.scheduler.schedulerEngine

          let start: string = _.minBy(events, 'startDate')!.startDate
          let end: string = _.maxBy(events, 'endDate')!.endDate

          if(moment(start).isBefore(moment(this.currentPeriod.startDate), 'day')) {
            start = this.currentPeriod.startDate.toISOString()
          }

          if (moment(end).isAfter(moment(this.currentPeriod.startDate), 'day')) {
            end = this.currentPeriod.endDate.toISOString()
          }

          engine.setStartDate(moment(start).toDate())
          engine.setEndDate(moment(end).toDate())
        }

        return EmployeeEvent.createListFromResponse(events, view, this.allowShiftDragAndDrop)
      },

      async fetchShiftList (): Promise<Array<PlannedShift>> {
        let view: ViewEnum = ViewEnum.TimelineMonth
        if (this.period === DatePeriodEnum.Week) {
          view = ViewEnum.TimelineWeek
        } else if (this.period === DatePeriodEnum.Day) {
          view = ViewEnum.Day
        } else if (this.period === DatePeriodEnum.Year) {
          view = ViewEnum.TimelineYear
        } else if (this.period === DatePeriodEnum.WorkingWeek) {
          view = ViewEnum.TimelineWorkDaysWeek
        }

        const payload: ShiftListPayload = {
          profitCenterId: this.companyFilterValue.profitCenter!.id,
          departmentId: this.companyFilterValue.department!.id,
          calendarDate: this.currentPeriod.formattedStartDate('DD/MM/YYYY'),
          view: view
        }

        try {
          const data: ShiftPlanResponse | false = await this.$store.dispatch(LOAD_SHIFTS, payload)
          if (data) {
            return PlannedShift.createListFromResponse(data)
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
            return []
          }
        } catch {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
          return []
        }
      },

      async fetchCapacityList (item: Array<EmployeeResource>): Promise<Array<EmployeeCapacity>> {
        let view: ViewEnum = ViewEnum.Month
        if (this.period === DatePeriodEnum.Week) {
          view = ViewEnum.Week
        } else if (this.period === DatePeriodEnum.Day) {
          view = ViewEnum.Day
        } else if (this.period === DatePeriodEnum.Year) {
          view = ViewEnum.TimelineYear
        } else if (this.period === DatePeriodEnum.WorkingWeek) {
          view = ViewEnum.TimelineWorkDaysWeek
        }

        const employeeIdList = item.map((i: EmployeeResource) => {
          return i.id
        })

        const payload: EmployeeCapacityPayload = {
          employeeIdList: employeeIdList,
          calendarDate: this.currentPeriod.formattedStartDate('DD/MM/YYYY'),
          view: view
        }

        return await this.$store.dispatch(FETCH_CAPACITY_LIST, payload)
      },
      // </editor-fold>

      async updateDataSet (): Promise<void> {
        const profitCenter = this.companyFilterValue.profitCenter
        const department = this.companyFilterValue.department

        if (profitCenter && department) {
          this.loading = true

          const promise1: Promise<EmployeeEvent[]> = this.fetchEventList()
          const promise2: Promise<PlannedShift[]> = this.fetchShiftList()

          const values = await Promise.all([promise1, promise2])

          this.employeeEventList = values[0]
          employeeEventListIndexedBySerieId = {}
          for(let i in this.employeeEventList) {
            const ee: EmployeeEvent = this.employeeEventList[i]
            if(ee.projectSerieId) {
              if (employeeEventListIndexedBySerieId[ee.projectSerieId]) {
                employeeEventListIndexedBySerieId[ee.projectSerieId].push(ee)
              } else {
                employeeEventListIndexedBySerieId[ee.projectSerieId] = [ee]
              }
            }
          }

          this.shiftList = values[1]
          this.employeeResourceList = this.createEmployeeResources()
          this.createAvatar()
          this.createFloaterEmployeeResources()
          //this.schedulerResources = this.employeeResourceList
          this.schedulerEvents =  this.employeeEventList
          this.updateSchedulerData()
          this.loading = false

          //this.createFloaterEmployeeResources()
          /*if (this.period !== DatePeriodEnum.Year) {
            this.employeeCapacityList = await this.fetchCapacityList(this.employeeResourceList)
          }*/
          //this.createAvatar()
        } else {
          this.currentShift = undefined
        }
      },

      updateSchedulerData (): void {
        this.filterScheduler()

        if(this.planningDetailData) {
          this.planningDetailData = this.employeeResourceList.find((item:EmployeeResource) => item.id === this.planningDetailData.id)
        }

        if (this.period !== DatePeriodEnum.Year) {
          this.fetchCapacity()
        }

        if (this.companyFilterValue.department) {
          this.loadMessages()
        }
      },

      async fetchCapacity (): Promise<void> {
        this.employeeCapacityList = await this.fetchCapacityList(this.employeeResourceList)
        this.schedulerResources = EmployeeResource.createListWithCapacity(this.schedulerResources, this.employeeCapacityList)
      },

      createEmployeeResources (): Array<EmployeeResource> {
        const profitCenter = this.companyFilterValue.profitCenter
        const department = this.companyFilterValue.department

        if (profitCenter && department) {
          const employees = this.companyStructure.employeeList
            .filter((item: Employee) => item.profitCenter === profitCenter.id)
            .filter((item: Employee) => item.department === department.id)
            .filter((item: Employee) => item.planbar)

          this.filteredEmployees = []
          employees.forEach((item: Employee) => {
            this.filteredEmployees.push(item)
          })

          return EmployeeResource.createListFromConfiguration(employees, this.companyStructure.planningGroupList, this.employeeEventList)
        }

        return []
      },

      createFloaterEmployeeResources (): void {
        const profitCenter = this.companyFilterValue.profitCenter
        const department = this.companyFilterValue.department
        let floaterList: Array<EmployeeResource> = []

        if (profitCenter && department) {
          let employees: Array<Employee> = []

          this.companyStructure.employeeList.forEach((item: Employee) => {
            if (item.floaterDepartments.includes(department.id)) {
              if (item.planbar && item.floater) {
                employees.push(item)
              }
            }
          })

          employees.forEach((item: Employee) => {
            this.filteredEmployees.push(item)
          })

          floaterList = EmployeeResource.createFloaterList(employees, this.companyStructure.planningGroupList, this.employeeEventList)
        }

        floaterList.forEach((item: EmployeeResource) => {
          this.employeeResourceList.push(item)
        })
      },

      createAvatar (): void {
        if (this.companyFilterValue.department) {
          const avatar = EmployeeResource.createAvatar(this.employeeEventList, this.companyFilterValue.department.id)
          if (avatar) {
            this.employeeResourceList.push(avatar)
          }
        }
      },

      openShiftEditor (/*data: any*/): void {
        this.showShiftEditor = true
        //this.shiftEditorData = data.eventRecord
      },

      closeShiftEditor (): void {
        this.showShiftEditor = false
        this.shiftEditorPlanningPayload = undefined
      },

      async loadMessages (): Promise<any> {
        const messagesList = await this.$store.dispatch(MESSAGING_LOAD_NEW_MESSAGES)
        this.$store.commit(MESSAGING_SET_MESSAGES_DATA_MUTATION, messagesList)
      },

      onShiftEditDialogClose (): void {
        this.showShiftEditDialog = false
      },

      onSerieBtnClick (): void {
        this.isEdittingSerie = true
        this.isEdittingShift = false
        this.openEditStepper()
        this.showShiftEditDialog = false
      },

      onShiftBtnClick (): void {
        this.isEdittingSerie = false
        this.isEdittingShift = true
        this.openEditStepper()
        this.showShiftEditDialog = false
      },

      onSchedulerEventClick (e: any): void {
        this.unselect = true
        this.selectedShift = undefined
        // @ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine
        engine.clearEventSelection()

        this.selectedDetailId = e.eventRecord.data.projectShiftDetailId
        this.projectId = e.eventRecord.data.projectId
      },

      onSchedulerEventDblClick (e: any): void {
        this.selectedDetailId = e.eventRecord.data.projectShiftDetailId
        const selectedProjectSerieId: number = e.eventRecord.data.projectSerieId

        const foundShift: PlannedShift | undefined = this.shiftList.find((item: PlannedShift) => item.projectSerie === selectedProjectSerieId)

        if(foundShift) {
          this.selectedTemplateId = foundShift.shift
          this.onActivateFastPlanning(true)
        } else {
          this.selectedTemplateId = undefined
        }
      },

      onFixShiftClick (): void {
        this.fixShift()
      },

      async fixShift (): Promise<void> {
        if (this.checkedList.length > 0) {
          let payload: Array<number> = []
          this.checkedList.forEach((item: CheckedShiftList) => {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === item.projectSerie && i.projectId) {
                payload.push(i.projectId)
              }
            })
          })
          try {
            this.loading = true
            const response: ResponseBase = await this.$store.dispatch(FIX_PROJECT_SERIE, payload)
            if(!response.IsError) {
              this.updateDataSet()
              this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        } else if (this.selectedShift) {
          let payload: Array<number> = []
          if(this.isSelectProjectSerieActive) {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === this.selectedShift.projectSerieId && i.projectId) {
                payload.push(i.projectId)
              }
            })
          } else {
            payload.push(this.selectedShift.projectId)
          }
          try {
            this.loading = true
            const response: ResponseBase = await this.$store.dispatch(FIX_PROJECT_SERIE, payload)
            if(!response.IsError) {
              this.updateDataSet()
              this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        }
      },

      onCompleteShift (): void {
        this.showCompleteShiftWarningDialog = true
      },

      onCompleteShiftWarningDialogClose (): void {
        this.showCompleteShiftWarningDialog = false
      },

      async completeShift (): Promise<void> {
        this.showCompleteShiftWarningDialog = false
        if (this.checkedList.length > 0) {
          let payload: Array<number> = []
          this.checkedList.forEach((item: CheckedShiftList) => {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === item.projectSerie && i.projectId) {
                payload.push(i.projectId)
              }
            })
          })
          try {
            this.loading = true
            const response: ResponseBase = await this.$store.dispatch(COMPLETE_SHIFT_LIST, payload)
            if(!response.IsError) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        } else if (this.selectedShift) {
          let payload: Array<number> = []
          if(this.isSelectProjectSerieActive) {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === this.selectedShift.projectSerieId && i.projectId) {
                payload.push(i.projectId)
              }
            })
          } else {
            payload.push(this.selectedShift.projectId)
          }

          try {
            this.loading = true
            const response: ResponseBase = await this.$store.dispatch(COMPLETE_SHIFT_LIST, payload)
            if(!response.IsError) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        }
      },

      onActivateShift (): void {
        this.showActivateShiftWarningDialog = true
      },

      onActivateShiftWarningDialogClose (): void {
        this.showActivateShiftWarningDialog = false
      },

      async activateShift (): Promise<void> {
        this.showActivateShiftWarningDialog = false
        if (this.checkedList.length > 0) {
          let payload: Array<number> = []
          this.checkedList.forEach((item: CheckedShiftList) => {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === item.projectSerie && i.projectId) {
                payload.push(i.projectId)
              }
            })
          })
          try {
            this.loading = true
            const response: boolean = await this.$store.dispatch(ACTIVATE_SHIFT_LIST, payload)
            if(response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        } else if (this.selectedShift) {
          let payload: Array<number> = []
          if(this.isSelectProjectSerieActive) {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === this.selectedShift.projectSerieId && i.projectId) {
                payload.push(i.projectId)
              }
            })
          } else {
            payload.push(this.selectedShift.projectId)
          }

          try {
            this.loading = true
            const response: boolean = await this.$store.dispatch(ACTIVATE_SHIFT_LIST, payload)
            if(response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        }
      },

      onDeactivateShift (): void {
        this.showDeactivateShiftWarningDialog = true
      },

      onDeactivateShiftWarningDialogClose (): void {
        this.showDeactivateShiftWarningDialog = false
      },

      async deactivateShift (): Promise<void> {
        this.showDeactivateShiftWarningDialog = false
        if (this.checkedList.length > 0) {
          let payload: Array<number> = []
          this.checkedList.forEach((item: CheckedShiftList) => {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === item.projectSerie && i.projectId) {
                payload.push(i.projectId)
              }
            })
          })
          try {
            this.loading = true
            const response: boolean = await this.$store.dispatch(DEACTIVATED_SHIFT_LIST, payload)
            if(response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        } else if (this.selectedShift) {
          let payload: Array<number> = []
          if(this.isSelectProjectSerieActive) {
            this.schedulerEvents.forEach((i: EmployeeEvent) => {
              if(i.projectSerieId === this.selectedShift.projectSerieId && i.projectId) {
                payload.push(i.projectId)
              }
            })
          } else {
            payload.push(this.selectedShift.projectId)
          }

          try {
            this.loading = true
            const response: boolean = await this.$store.dispatch(DEACTIVATED_SHIFT_LIST, payload)
            if(response) {
              this.editNote(NoteEditMenu.Shift)
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          } finally {
            this.loading = false
            this.showSnackbar = true
          }
        }
      },

      onAutoPlanningButtonClick (): void {
        this.autoPlanningShift()
      },

      async autoPlanningShift (): Promise<void> {
        if(this.checkedList.length > 0 || this.selectedShift.projectSerieId) {
          let projectSerieList: Array<number> = []
          if(this.checkedList.length > 0) {
            this.checkedList.forEach((item: CheckedShiftList) => {
              projectSerieList.push(item.projectSerie)
            })
          } else {
            projectSerieList.push(this.selectedShift.projectSerieId)
          }
          const payload: SchedulerAutoPlanningPayload = {
            projectSerieList: projectSerieList,
            startDate: moment(this.currentPeriod.startDate).format('YYYY-MM-DD HH:mm').toString(),
            endDate: moment(this.currentPeriod.endDate).format('YYYY-MM-DD HH:mm').toString()
          }
          try {
            this.loading = true
            let response: boolean = await this.$store.dispatch(SCHEDULER_AUTO_PLANNING, payload)
            if(response) {
              this.updateDataSet()
              this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
              this.snackbarState = SnackbarStateEnum.Success
            } else {
              this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
              this.snackbarState = SnackbarStateEnum.Error
            }
          } catch (e) {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
          }
          this.loading = false
          this.showSnackbar = true
        }
      },

      onSchedulerCellDblClick (e: any): void {
        if(e.column.data.field === 'fullName' && this.currentPeriod.period !== 'year') {
          this.planningDetailData = e.record.data
          this.showEmployeePlanningDetailDialog = true
        } else if(e.column.data.field === 'note') {
          this.selectedEmployee = e.record.data
          this.editNote(NoteEditMenu.Employee)
        }
      },

      onSchedulerCellClick (e: any): void {
        if(e.column.data.field === 'fullName') {
          this.selectedEmployee = e.record.data
        }
      },

      onEmployeePlanningDetailDialogClose (): void {
        this.planningDetailData = undefined
        this.showEmployeePlanningDetailDialog = false
      },

      eventRenderer ({ eventRecord, tplData }: any): any {
        tplData.top += 17
        tplData.clippedEnd = true

        let breakList: any = []
        if(eventRecord.data.shiftBreakList) {
          breakList = eventRecord.data.shiftBreakList.map((item: ShiftBreak) => {
            let startBreak
            let endBreak

            if((moment(eventRecord.data.startDate).hour() * 60) + moment(eventRecord.data.startDate, 'HH:mm').minutes() > (moment(item.startBreak, 'HH:mm').hour() * 60) + moment(item.startBreak, 'HH:mm').minutes()) {
              startBreak = new Date(moment(moment(eventRecord.data.startDate).add(1, 'days').startOf('day').format("YYYY-MM-DD") +` ${item.startBreak}`).toISOString())
              endBreak = new Date(moment(moment(eventRecord.data.startDate).add(1, 'days').startOf('day').format("YYYY-MM-DD") +` ${item.endBreak}`).toISOString())
            } else {
              startBreak = new Date(moment(moment(eventRecord.data.startDate).startOf('day').format("YYYY-MM-DD") +` ${item.startBreak}`).toISOString())
              endBreak = new Date(moment(moment(eventRecord.data.startDate).startOf('day').format("YYYY-MM-DD") +` ${item.endBreak}`).toISOString())
            }

            const startOffset = DateHelper.diff(new Date(eventRecord.data.startDate), startBreak)
            const endOffset = DateHelper.diff(startBreak, endBreak)

            //@ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine

            let left
            let width

            if((moment(eventRecord.data.startDate).hour() * 60) + moment(eventRecord.data.startDate, 'HH:mm').minutes() > (moment(item.startBreak, 'HH:mm').hour() * 60) + moment(item.startBreak, 'HH:mm').minutes()) {
              let dateToPx
              if(this.currentPeriod.period === 'day') {
                dateToPx = (date: Date) => engine.getCoordinateFromDate(date)
                left = dateToPx(DateHelper.add(new Date(moment(moment(eventRecord.data.startDate).add(1, 'days').startOf('day').format("YYYY-MM-DD")).toISOString()), startOffset))
                width = dateToPx(DateHelper.add(new Date(moment(moment(eventRecord.data.startDate).add(1, 'days').startOf('day').format("YYYY-MM-DD")).toISOString()), endOffset))
              } else {
                dateToPx = (date: Date) => engine.getCoordinateFromDate(date) - tplData.left
                left = dateToPx(DateHelper.add(eventRecord.data.startDate, startOffset))
                width = dateToPx(DateHelper.add(eventRecord.data.startDate, endOffset))
              }
            } else {
              const dateToPx = (date: Date) => engine.getCoordinateFromDate(date) - tplData.left
              left = dateToPx(DateHelper.add(eventRecord.data.startDate, startOffset))
              width = dateToPx(DateHelper.add(eventRecord.data.startDate, endOffset))
            }

            return {start: new Date(startBreak), end: new Date(endBreak), startOffset: startOffset, endOffset: endOffset, left: left, width: width}
          })
        }

        const item: any = {start: new Date(moment(eventRecord.data.startDate).endOf('date').toISOString()), end: new Date(moment(eventRecord.data.endDate).endOf('date').toISOString()), startOffset: 0, endOffset: 0, left: 0, width: 0}

        item.startOffset = DateHelper.diff(item.start, new Date(eventRecord.data.startDate))
        item.endOffset = DateHelper.diff(new Date(eventRecord.data.endDate), item.end)

        //@ts-ignore
        const engine = this.$refs.scheduler.schedulerEngine

        const dateToPx = (date: Date) => engine.getCoordinateFromDate(date) - tplData.left
        item.left = dateToPx(DateHelper.add(eventRecord.data.startDate, item.startOffset))
        item.width = dateToPx(DateHelper.add(eventRecord.data.startDate, item.endOffset))

        let width: number = tplData.width + item.width - 2

        if(moment(eventRecord.data.startDate) < moment(this.currentPeriod.startDate)) {
          const dtp = (date: Date) => engine.getCoordinateFromDate(date)
          const widthOffset: number = dtp(DateHelper.add(this.currentPeriod.startDate, item.endOffset))
          width = tplData.width + tplData.left + widthOffset -2
        }


        const b: any = breakList.map((i: any) => {
          return `<div  class="nested" style="left: ${i.left}px; width: ${i.width}px; background-image: repeating-linear-gradient(45deg, ${eventRecord.data.eventColor}, ${eventRecord.data.eventColor} 5px, #fff 5px, #fff 10px)"></div>`
        })

        let c: string = ''
        if (tplData.event.type === 'floater' ) {
          if(breakList.length > 0) {
            c = `<div class="event" style="width: ${tplData.width}px; font-weight: bold !important">
              ${b.join()}
              <div class="event-text" style="width: ${tplData.width}px; font-weight: bold !important">${eventRecord.data.name}</div>
            </div>`
          } else {
            c =`<div class="event" style="width: ${tplData.width}px; font-weight: bold !important">${eventRecord.data.name }</div>`
          }
        } else if(tplData.event.type === 'absence') {
          c = `<div  class="event" style="width: ${width}px">${eventRecord.data.name}</div>`
        } else {
          if(breakList.length > 0) {
            c = `<div  class="event" style="width: ${width}px">
              ${b.join()}
              <div class="event-text" style="width: ${width}px; font-weight: bold !important">${eventRecord.data.name}</div>
            </div>`
          } else {
            c = `<div  class="event" style="width: ${width}px">${eventRecord.data.name}</div>`
          }
        }

        let identificator: string = `${moment(eventRecord.data.startDate).format('YYYY-MM-DD')}-${eventRecord.data.id}`

      return `<div class="event-template ${identificator}">
                ${c}
              </div>`
      },

      setTimeRanges (startDate: Date, endDate: Date): void {
        let start = moment(startDate)
        let end = moment(endDate)
        let day = 0

        let result = this.holidayList
        let current = start.clone()

        while (current.day(7 + day).isBefore(end)) {
          const sun = current.clone().format('YYYY-MM-DD')
          const sat = moment(current.clone()).subtract(1, 'd').format('YYYY-MM-DD')

          const foundSun: TimeRange | undefined = _.find(this.holidayList, { startDate: sun })
          const foundSat: TimeRange | undefined = _.find(this.holidayList, { startDate: sat })

          if(!foundSun) {
            result.push({ startDate: sun, duration: 1, durationUnit: 'day' })
          }
          if(!foundSat) {
            result.push({ startDate: sat, duration: 1, durationUnit: 'day' })
          }
        }

        this.timeRanges = result
      },

      async onSchedulerSettingsChange (item: SchedulerSettings): Promise<void> {
        this.setSchedulerSettings(item)
        if(item.code === 'FULLD') {
          this.updateDataSet()
        } else if (item.code === 'LPM') {
          this.filterScheduler()
        }

        await this.$store.dispatch(SAVE_SCHEDULER_SETTINGS, item)
      },

      setSchedulerSettings(item: SchedulerSettings): void {
        switch (item.code) {
          case 'LPM':
            this.showOnlyEmployeesWithPlanning = item.value
            break
          case 'MNA':
            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.columns.topColumns[7].hidden = !item.value
            break
          case 'CAP':
            if(this.currentPeriod.period !== DatePeriodEnum.Year) {
              // @ts-ignore
              const engine = this.$refs.scheduler.schedulerEngine
              engine.columns.topColumns[3].hidden = !item.value
            }
            break
          case 'MGAZ':
            // @ts-ignore
            const engine = this.$refs.scheduler.schedulerEngine
            engine.columns.topColumns[6].hidden = !item.value
            break
          case 'ISTS':
            if(this.currentPeriod.period !== DatePeriodEnum.Year) {
              // @ts-ignore
              const engine = this.$refs.scheduler.schedulerEngine
              engine.columns.topColumns[5].hidden = !item.value
            }
            break
          case 'PLAN':
            if(this.currentPeriod.period !== DatePeriodEnum.Year) {
              // @ts-ignore
              const engine = this.$refs.scheduler.schedulerEngine
              engine.columns.topColumns[4].hidden = !item.value
            }
            break
          case 'WEEK':
            if(item.value) {
              this.showWeekPeriod = true
            } else {
              this.showWeekPeriod = false
            }
            break
          case 'FULLD':
            if(item.value) {
              this.isAllDayLong = true
              this.$store.dispatch(SET_IS_ALL_DAY_LONG, true)
            } else {
              this.isAllDayLong = false
              this.$store.dispatch(SET_IS_ALL_DAY_LONG, false)
            }
            break
        }
      },

      showAdditionalServicesDialog (item: any): void {
        this.showAdditionalServices = true
        this.additionalServicesTitle = item.label
        this.additionalServicesAction = item.code
      },

      onAdditionalServicesDialogClose (): void {
        this.showAdditionalServices = false
        this.additionalServicesTitle = ''
        this.additionalServicesAction = null
      },

      async getToolTip (data: any): Promise<string> {
        //const securityData = this.$store.getters[GET_SECURITY_DATA]
        //const addressFilteredSchedulerData = securityData.filter((item: SecurityData) => item.area === 'menu')
        let showAddressTooltip = securityService.isVisible(SecurityArea.Planning, SecurityComponent.SelectBoxAdress)
        let tooltipDepartment: string = ''

        const startText: string = moment(data.eventRecord.data.startDateOriginal).format('HH:mm')
        const endText: string = moment(data.eventRecord.data.endDateOriginal).format('HH:mm')
        const startDate: string = moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY HH:mm')
        const endDate: string = moment(data.eventRecord.data.endDateOriginal).format('DD.MM.YYYY HH:mm')

        if(showAddressTooltip && (data.eventRecord.type === 'shift' || data.eventRecord.type === 'floater' || data.eventRecord.type === 'originalShift')) {
          const response: NoteTooltip = await this.$store.dispatch(FETCH_SHIFT_TOOLTIP, data.eventRecord.data.projectShiftDetailId)
          let address: string = response.address ? response.address.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''
          let preferencesData: string = response.preferences ? response.preferences.replace(/(?:\r\n|\r|\n)/g, '<br>') : ''

          let tooltipDepartment: string = ''
          let preferences: string = ''
          if(!this.isCapelo) {
            tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${response.departmentName}</td>
              </tr>`
          } else {
            preferences = `<tr>
                <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.preferences')} :</td>
                <td>${preferencesData}</td>
              </tr>`
          }

          if(data.eventRecord.data.isReplacement) {
            return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td> ${data.eventRecord.type === 'originalShift' ? data.eventRecord.resource.fullName : response.employeeName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.replacement')} :</td>
                    <td>${data.eventRecord.type === 'originalShift' ? response.responsibleName : data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  <tr>
                    <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.address')}:</td>
                    <td>${data.eventRecord.data.addressNumber} <br> ${address}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.email')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="mailto:${response.email}")> ${response.email} </a>
                    </td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.mobile')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.mobile}")> ${response.mobile} </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                  ${preferences}
                </table>
              </dl>
              `
          } else {
            return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  <tr>
                    <td style="vertical-align:top; padding-right: 10px">${this.$i18n.t('planningPage.address')}:</td>
                    <td>${data.eventRecord.data.addressNumber} <br> ${address}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.email')}:</td>
                     <td>
                      <a style="color: black; text-decoration: none" href="mailto:${response.email}")> ${response.email} </a>
                    </td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.mobile')}:</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.mobile}")> ${response.mobile} </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                  ${preferences}
                </table>
              </dl>
              `
          }
        } else {

          let additionalTooltip = {
            departmentName: '',
            employeeMobile: '',
            medicalCertificateUntil: '',
            absenceNote: ''
          }
          if(data.eventRecord.data.type === 'absence') {
            const responseTooltip: any = await this.$store.dispatch(FETCH_ABSENCE_TOOLTIP, data.eventRecord.data.absenceId)
            if(responseTooltip && responseTooltip.Tooltip) {
              additionalTooltip.departmentName = responseTooltip.Tooltip.AbteilungBezeichnung ? responseTooltip.Tooltip.AbteilungBezeichnung : ''
              additionalTooltip.employeeMobile = responseTooltip.Tooltip.MAMobil ? responseTooltip.Tooltip.MAMobil : ''
              additionalTooltip.medicalCertificateUntil = responseTooltip.Tooltip.Arztzeugnis_GueltigBis ? `<tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.medicalCertificateUntil')}:</td>
                    <td>${moment(responseTooltip.Tooltip.Arztzeugnis_GueltigBis).format('DD.MM.YYYY')}</td>
                  </tr>` : ''

              additionalTooltip.absenceNote = responseTooltip.Tooltip.Bemerkung && responseTooltip.Tooltip.Bemerkung.length > 0 ? `<tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${responseTooltip.Tooltip.Bemerkung}</td>
                  </tr>` : ''
            }

            if(!this.isCapelo) {
              tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${additionalTooltip.departmentName}</td>
              </tr>`
            }

            return `
          <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${additionalTooltip.employeeMobile}")> ${additionalTooltip.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('absencesPage.absence')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} :</td>
                    <td>${startDate}</td>
                  </tr>
                   <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.end')} :</td>
                    <td>${endDate}</td>
                  </tr>
                  ${additionalTooltip.medicalCertificateUntil}
                  ${additionalTooltip.absenceNote}
                </table>
              </dl>`

          } else if (data.eventRecord.data.type === 'calendar') {
            const responseTooltip: any = await this.$store.dispatch(FETCH_CALENDAR_ART_TOOLTIP, data.eventRecord.data.kaId)
            if(responseTooltip && responseTooltip.Tooltip) {
              additionalTooltip.departmentName = responseTooltip.Tooltip.AbteilungBezeichnung ? responseTooltip.Tooltip.AbteilungBezeichnung : ''
              additionalTooltip.employeeMobile = responseTooltip.Tooltip.MAMobil ? responseTooltip.Tooltip.MAMobil : ''
            }

            if(!this.isCapelo) {
              tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${additionalTooltip.departmentName}</td>
              </tr>`
            }

            return `
          <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${additionalTooltip.employeeMobile}")> ${additionalTooltip.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.calendarEvent')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / KW ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${responseTooltip.Tooltip.Beschreibung ? responseTooltip.Tooltip.Beschreibung : ''}</td>
                  </tr>
                </table>
              </dl>`
          }  else if (data.eventRecord.data.type === 'shift' || data.eventRecord.type === 'originalShift' || data.eventRecord.type === 'floater') {
            const response: NoteTooltip = await this.$store.dispatch(FETCH_SHIFT_TOOLTIP, data.eventRecord.data.projectShiftDetailId)
            let tooltipDepartment = `<tr>
                <td style="padding-right: 10px">${this.$i18n.t('planningPage.department')} :</td>
                <td>${response.departmentName}</td>
              </tr>`

            return `
              <dl>
                <table>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employee')} :</td>
                    <td>${data.eventRecord.resource.fullName}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.employeeMobile')} :</td>
                    <td>
                      <a style="color: black; text-decoration: none" href="tel:${response.employeeMobile}")> ${response.employeeMobile} </a>
                    </td>
                  </tr>
                  ${tooltipDepartment}
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.tooltipShiftLabel')} :</td>
                    <td>${data.eventRecord.data.name}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.date')} :</td>
                    <td>${moment(data.eventRecord.data.startDateOriginal).format('DD.MM.YYYY')} / ${this.$i18n.t('calendarWeek')} ${moment(data.eventRecord.data.startDateOriginal).isoWeek()}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.start')} - ${this.$i18n.t('planningPage.end')} :</td>
                    <td>${startText} - ${endText}</td>
                  </tr>
                  <tr>
                    <td style="padding-right: 10px">${this.$i18n.t('planningPage.note')}:</td>
                    <td>${response.note}</td>
                  </tr>
                </table>
              </dl>
              `
          }

          return ''
        }
      },

      getRouteData (): Object {
        let data: any = undefined
        try {
          //@ts-ignore
          data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
        } catch (e) {
          data = {}
        }

        return data
      },

      setDataFromRoute () {
        let data: any = this.getRouteData()

        this.currentPeriod = data && data.currentPeriod && data.currentPeriod.startDate && moment(data.currentPeriod.startDate).isValid() && data.currentPeriod.period ? DatePeriod.createFromDateString(moment(data.currentPeriod.startDate).format('YYYY-MM-DD'), data.currentPeriod.period) : DatePeriod.createFromNow(DatePeriodEnum.Month)
        this.schedulerStartDate = this.currentPeriod.startDate
        this.schedulerEndDate = this.currentPeriod.endDate
      }

    },

    async created () {
      this.setDataFromRoute()

      this.loading = true
      //const securityData = this.$store.getters[GET_SECURITY_DATA]
      this.allowShiftDragAndDrop = securityService.isVisible(SecurityArea.PlanningPlayground, SecurityComponent.DragDropForSchichts)
      this.isEventTextOver = securityService.isVisible(SecurityArea.PlanningPlayground, SecurityComponent.EventTextOver)
      if(this.isEventTextOver) {
        document.documentElement.style.setProperty('--textOverflow', 'inherit')
      } else {
        document.documentElement.style.setProperty('--textOverflow', 'hidden')
      }

      //const filteredData = securityData.filter((item: SecurityData) => item.area === "planning-bar")
      const showCapacity = securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.ToolbarFunctions)
      this.schedulerColumns[3].hidden = !showCapacity
      this.allowShiftDelete = securityService.isVisible(SecurityArea.PlanningBar, SecurityComponent.IconDelete)

      //const addressFilteredSchedulerData = securityData.filter((item: SecurityData) => item.area === 'menu')
      //let showAddressTooltip = addressFilteredSchedulerData.filter((item: SecurityData) => item.component === 'address')[0].visibility
      //let tooltipDepartment: string = ''

      this.eventContextMenuFeature = {
        items: {
          deleteEvent : {
            text : this.$i18n.t('planningPage.eventMenuTooltip'),
            icon : 'b-fa b-fa-fw b-fa-info-circle',
            onItem: ({eventRecord}: any) => {
              let identificator: string = `${moment(eventRecord.data.startDate).format('YYYY-MM-DD')}-${eventRecord.data.id}`
              let elem: any = document.getElementsByClassName(identificator) //document.querySelector(`[data-event-id="${eventRecord.data.id}"]`)

              const tooltip = new Tooltip({
                align: 't-b',
                autoClose: false,
                closable: true,
                preventTooltipOnTouch: true,
                allowOver: true,
                hideDelay : 99999999,
                autoShow: true,
                positioned: true,
                draggable: true,
                //forSelector : `[data-event-id="${eventRecord.data.id}"]`,
                forElement: elem && elem[0] ? elem[0] : undefined,
                header: {
                  cls: eventRecord.data.type === 'shift' ? 'white-underlay' : '',
                  title: eventRecord.data.colorCode},
                bbar: {
                  cls: 'tooltip-bbar',
                  items: [
                    { cls: 'tooltip-empty' },
                    {
                      text : this.$i18n.t('planningPage.tooltipCloseAll'),
                      //icon : 'b-fa b-fa-close',
                      cls: 'tooltip-closeall',
                      onClick: () => {
                        this.tooltipList.forEach((item: any) => {
                          item.close()
                        })

                      } }
                  ]
                },
                listeners : {
                  // @ts-ignore
                  beforeShow : ({ source : tip }) => {
                    tip.html = this.getToolTip({eventRecord})
                  },
                  hide: () => {
                    tooltip.disable()
                  },
                }
              })

              // @ts-ignore
              const header: any = document.querySelector(`header[data-owner-cmp="${tooltip.currentElement.id}"]`)
              if(eventRecord.style.includes("background-image")) {
                header.style = eventRecord.style
              } else {
                header.style.backgroundColor = eventRecord.eventColor
              }

              const headerTitle: any = header.children
              headerTitle[0].style.color = getColorContrast(eventRecord.eventColor)
              headerTitle[1].style.color = getColorContrast(eventRecord.eventColor)

              this.tooltipList.push(tooltip)

              tooltip.disable()
            }
          },
          extraItem: {
            text: this.$i18n.t('planningPage.eventMenuDelete'),
            icon : 'b-fa b-fa-fw b-fa-trash',
            onItem: ({eventRecord}: any) => {
              if(eventRecord.data.type === 'shift') {
                this.selectedShift = eventRecord.data
                this.onDeleteShiftClick()
              } else if(eventRecord.data.type === 'calendar') {
                this.selectedShift = undefined
                this.selectedCalendarEvent = eventRecord.data
                this.onDeleteShiftClick()
              }
            }
          }
        }
      }

      this.eventTooltipFeature = {
        disabled: true,
      }
    },

    async beforeMount() {
      this.schedulerSettings = await this.$store.dispatch(FETCH_SCHEDULER_SETTINGS)
      this.schedulerSettings.forEach((item: SchedulerSettings) => {
        this.setSchedulerSettings(item)
      })
    },

    async mounted () {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      this.companyStructure = this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]

      const holidays: Array<Holiday> = this.$store.getters[COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST]
      holidays.forEach((item: Holiday) => {
        const date: string = moment(item.date, 'DD.MM.YYYY').format('YYYY-MM-DD')
        this.holidayList.push({ startDate : date, duration : 1, durationUnit : 'day' })
      })
      this.setTimeRanges(this.currentPeriod.startDate, this.currentPeriod.endDate)

      // @ts-ignore
      const engine = this.$refs.scheduler.schedulerEngine

      engine.on({
        beforeEventDelete: (event: any) => {
          if((this.allowShiftDelete || this.securityLevel === 7) && event.eventRecords[0].type === 'shift') {
            this.onDeleteShiftClick()
          } else if ((this.allowShiftDelete || this.securityLevel === 7) && event.eventRecords[0].type === 'calendar') {
            this.selectedShift = undefined
            this.selectedCalendarEvent = event.eventRecords[0].data
            this.onDeleteShiftClick()
          }

          return false
        }
      })
    }
  }
)
